import React from "react"
import achiStyle from "./Achievements.module.css"
import Heading from "./Heading"
import CardsContainer from "./CardsContainer"

const Achievements = () => {
  return (
    <div className={achiStyle.achievements}>
      <Heading headingTxt="Achievements" />
      <CardsContainer />
    </div>
  )
}

export default Achievements
